import styled from 'styled-components';

export const Container = styled.div`
  padding: 0px;
  max-width: 100%;
  overflow-x: hidden;
`;

export const FormContainer = styled.div`
  padding: 24px;

  @media (max-width: 768px) {
    padding: 20px;
  }

  @media (max-width: 480px) {
    padding: 16px;
  }
`;

export const Header = styled.div`
  padding: 24px 18px;

  h3 {
    color: #393939;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    @media (max-width: 768px) {
      font-size: 16px;
    }

    @media (max-width: 480px) {
      font-size: 15px;
    }
  }

  @media (max-width: 768px) {
    padding: 20px 16px;
  }

  @media (max-width: 480px) {
    padding: 16px 12px;
  }
`;

export const FormTitle = styled.h4`
  font-size: 14px;
  font-weight: 800;
  line-height: 19px;
  margin: 10px 0 !important;
  color: #393939;

  @media (max-width: 768px) {
    font-size: 13px;
    line-height: 18px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const Line = styled.div`
  height: 1px;
  background: #364445;
`;

export const Form = styled.form`
  padding-bottom: 20px;

  label {
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0em;

    @media (max-width: 768px) {
      font-size: 13px;
      gap: 8px;
    }

    @media (max-width: 480px) {
      font-size: 12px;
    }
  }

  input {
    width: 100%;
    min-height: 44px;
    font-size: 16px !important; /* Previne zoom no iOS */

    @media (max-width: 768px) {
      min-height: 42px;
    }
  }

  .row input {
    margin-top: 0px;
  }

  .ui.grid > .row {
    padding-bottom: 0px;
  }

  @media (max-width: 768px) {
    padding-bottom: 16px;
  }

  @media (max-width: 480px) {
    padding-bottom: 12px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  align-items: center;
  width: 100%;
  margin-top: 15px;

  button {
    min-height: 44px;
  }

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 10px;

    button {
      width: 100%;
    }
  }

  @media (max-width: 480px) {
    gap: 8px;
  }
`;
